// src/components/ActionBox.jsx

import React from 'react';
import { Box } from '@mui/material';

const DrawerFooter = ({ children, sx = {}, id = 'actionsBox', ...props }) => {
  return (
    <Box
      id={id}
      data-rum-surface="drawer-footer"
      sx={{
        px: 3.7,
        py: 2.1,
        gap: '10px 19px',
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        backgroundColor: 'background.paper',
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default DrawerFooter;
